import { createSlice } from "@reduxjs/toolkit";
import { ORDER_TYPE, DISCOUNT_TYPE, SHIPPING_TYPE, ORDER_STATUS, FULFILLMENT_STATUS } from "../../../Common/constants";
import { formatNumericAmount } from "../../../Common/utils";
import moment from "moment";
const dateFormat = "YYYY-MM-DD";

const initialOrdersState = {
  listLoading: false,
  actionsLoading: false,
  modalActionsLoading: false,
  copyOrderEntity: null,
  stepperSearchResult: null,
  cartSearchResult: null,
  scanItem: [],
  scanBy: "",
  productEntities: [],
  customer: null,
  users: null,
  selectedCustomerHistory: null,
  orderListCustomerSearchResult: null,
  products: [],
  scanningProducts: [],
  orderProducts: [],
  coupon: "",
  couponDiscount: 0,
  productTotalCount: 0,
  completed: false,
  park: false,
  orderId: null,
  retrieveOrder: false,
  currentOrder: {},
  blukExecutingActionLoading:false,
  card: {
    requiresAction: false,
    paymentIntentClientSecret: "",
  },
  entities: [],
  miscItems: [],
  fulfillmentEntities: [],
  totalByStatus: {},
  fulfillmentTotalCount: 0,
  totalCount: 0,
  orderEntities: null,
  scaningProductInfo: { entities: [] },
  searchOrderDetail: [],
  skipTobaccoEligibilityTest: false,
  showDeliverySchedule: false,
  route: {},
  message: {
    error: null,
    success: null,
    cartError: null,
    cartWarning: null,
    cartSuccess: null,
    couponSuccess: null,
    couponError: null,
    modalError: null,
    modalSuccess: null,
    modalWarning: null,
  },
};

export const callTypes = {
  list: "list",
  actions: "actions",
  modalActions: "modalActions",
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState: initialOrdersState,
  reducers: {
    catchError: (state, action) => {
      // 
      state.message.error =
        action.payload.error.response && action.payload.error.response.data
          ? [action.payload.error.response.data.message, ...action.payload.error.response.data.errors]
          : action.payload.error.message;
      if (callTypes[action.payload.callType]) {
        state[`${action.payload.callType}Loading`] = false;
      }
    },

    startCall: (state, action) => {
      state.message.error = null;
      if (callTypes[action.payload.callType]) {
        state[`${action.payload.callType}Loading`] = true;
      }
    },
    startBlukExecutingActionLoading: (state, action) => {
      state.blukExecutingActionLoading = true;
    },
    endBlukExecutingActionLoading: (state, action) => {
      state.blukExecutingActionLoading = false;
    },
    startCallReturn: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    handleLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    handleShowDeliverySchedule: (state, action) => {
      state.showDeliverySchedule = action.payload;
    },
    handleSetInitialRoute: (state, action) => {
      state.route = action.payload; 
    },
    grailPay: (state, action) => {
      state.customer = { ...state.customer, grailpay_uuid: action.payload.uuid };
    },
    resetList: (state, action) => {
      state.productEntities = [];
    },
    productsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.message.error = null;
      state.productEntities = entities;
      state.productTotalCount = totalCount;
      state.products.map((product) => {
        state.productEntities = state.productEntities.filter((entity) => entity.id != product.id);
      });
    },
    orderProductsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.message.error = null;
      state.orderProducts = entities;
    },
    resetOrder: (state, action) => {
      state.productEntities = [];
      state.customer = {};
    },
    emptyOrderEntities: (state, action) => {
      state.orderEntities = [];
    },
    // create order
    orderCreated: (state, action) => {
      const { message, entity, park } = action.payload;
      state.copyOrderEntity = null;
      state.productEntities = [];
      // state.customer = null;
      state.products = [];
      state.coupon = "";
      state.couponDiscount = 0;
      state.listLoading = false;
      state.productTotalCount = 0;
      state.card = {
        requiresAction: false,
        paymentIntentClientSecret: "",
      };
      state.retrieveOrder = false;
      state.actionsLoading = false;
      state.message.error = null;
      state.message.couponError = null;
      state.message.success = message;
      state.message.couponSuccess = null;
      state.currentOrder = entity;
      state.completed = entity.status == ORDER_STATUS.PARKED.value ? false : true;
      state.park = park;
    },
    //orderReturning
    orderReturning: (state, action) => {
      const { message, entity } = action.payload;
      state.entities = [];
      state.actionsLoading = false;
      state.currentOrder = entity;
      state.copyOrderEntity = null;
      state.completed = true;
      state.message.success = message;
    },
    // select customer and remove the search result
    selectCustomer: (state, action) => {
      const currentDate = moment();
      const invoiceAging = action.payload.customer?.invoice_aging;
      const dueDate = invoiceAging ? currentDate.add(invoiceAging, "days").format(dateFormat) : currentDate.format(dateFormat);

      state.actionsLoading = false;
      state.message.error = null;
      state.customer = { ...action.payload.customer, dueDate: dueDate };
      state.cartSearchResult = null;
      state.stepperSearchResult = null;
    },

    selectedCustomerHistory: (state, action) => {
      state.actionsLoading = false;
      state.message.error = null;
      state.selectedCustomerHistory = action.payload.customer.id;
      state.cartSearchResult = null;
      state.stepperSearchResult = null;
    },
    removeSelectedCustomerHistory: (state, action) => {
      state.selectedCustomerHistory = null;
    },
    JreRenderList: (state, action) => {
      state.listLoading = action.payload;
    },
    orderRequiresAction: (state, action) => {
      state.actionsLoading = false;
      state.message.error = null;
      const { entity } = action.payload;
      state.card.requiresAction = entity.requires_action;
      state.card.paymentIntentClientSecret = entity.payment_intent_client_secret;
    },
    // Remove Customer
    removeSaleCustomer: (state, action) => {
      state.customer = action?.payload?.customer || null;
    },

    // set order
    setCurrentOrder: (state, action) => {
      state.currentOrder = action.payload;
    },

    // set customer
    setCustomer: (state, action) => {
      state.customer = action.payload;
    },

    // add product to cart
    scanProduct: (state, action) => {
      state.actionsLoading = false;
      state.message.error = null;
      const { entity, queryParams } = action.payload;
      console.log("...test",getInitialState().scanItem.push({products:entity,scanBy:queryParams.searchKey}));
      // if (entity.length && queryParams.withScanner) {
      //     state.scanItem = getInitialState().scanItem.push({products:entity,scanBy:queryParams.searchKey});
      //     // state.message.success = "Product Added Successfully"
      // } else {
      //   state.scanItem = [];
      //   // state.message.error = "Product Not Available or Out of Stock"
      // }
    },
    // add product to cart
    scanOrderDetail: (state, action) => {
      const { entities } = action.payload;
      state.scanningProducts = entities;
    },

    searchInSods: (state, action) => {
      const { entities } = action.payload;
      state.scanningProducts = entities;
    },
    searchOrderDetail: (state, action) => {
      const { entities } = action.payload;

      if (entities) {
        state.searchOrderDetail = entities;
      }
    },
    //deselect customer selected for order
    removeCustomer: (state) => {
      state.actionsLoading = false;
      state.message.error = null;
      state.customer = null;
      state.cartSearchResult = null;
    },
    quickCustomerCreated: (state, action) => {
      const { message, entity } = action.payload;
      state.modalActionsLoading = false;
      state.message.error = null;
      state.customer = entity;
      state.message.success = message;
    },
    //apply coupon on current order :save discount
    applyCoupon: (state, action) => {
      const { entity, message } = action.payload;
      state.actionsLoading = false;
      state.couponDiscount = { discount: entity?.discount, type: entity?.discount_type };
      state.message.couponError = !entity ? message : null;
      state.message.couponSuccess = entity ? message : null;
    },

    //apply coupon on current order :save discount
    addPayment: (state, action) => {
      const { entity, success } = action.payload;
      state.actionsLoading = false;
      // state.entities = state.entities.map((item) => {
      //   if (item.id === entity.id) {
      //     item = entity;
      //   }
      //   return item;
      // });
      state.message.success = success;
    },

    //change value of coupon
    changeCoupon: (state, action) => {
      state.actionsLoading = false;
      const { coupon } = action.payload;
      state.coupon = coupon;
    },
    //remove coupon applied on cart
    removeCoupon: (state, action) => {
      state.actionsLoading = false;
      state.couponDiscount = { discount: undefined, type: undefined };
      state.message.couponSuccess = null;
      state.message.couponError = null;
    },

    //change tobacco sale eligibility test
    changeTobaccoSaleEligibilityTest: (state, action) => {
      state.skipTobaccoEligibilityTest = action.payload.skipTobaccoEligibilityTest;
    },

    copyOrder: (state, action) => {
      state.actionsLoading = false;
      const { entity } = action.payload;
      state.copyOrderEntity = entity;
      state.orderId = entity.id ? entity.id : null;
      state.customer = entity.customer;
    },

    //change order complete status
    changeCompleteStatus: (state, action) => {
      const { status } = action.payload;
      state.completed = status;
      state.card = {
        requiresAction: false,
        paymentIntentClientSecret: "",
      };
    },

    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      state.message[type] = message;
      state.actionsLoading = false;
      state.modalActionsLoading = false;
    },

    removeScanItem: (state) => {
       state.scanItem = getInitialState().scanItem.shift();;
    },

    setSaleProducts: (state, action) => {
      state.productEntities = action.payload;
    },

    // getOrderById
    orderFetched: (state, action) => {
      state.actionsLoading = false;
      state.orderForEdit = action.payload.orderForEdit;
      state.message.error = null;
    },
    // findOrders
    ordersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.message.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    // updateOrder
    orderUpdated: (state, action) => {
      state.message.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.order.id) {
          return action.payload.order;
        }
        return entity;
      });
    },
    // change order status
    changeOrderStatus: (state, action) => {
      state.message.error = null;
      state.actionsLoading = false;
      const { status } = action.payload;
      state.message.success = status;
      // if (
      //   Object.keys(FULFILLMENT_STATUS)
      //     .map((status) => FULFILLMENT_STATUS[status].value)
      //     .includes(order.status)
      // ) {
      //   state.fulfillmentEntities = state.fulfillmentEntities.map((entity) => {
      //     if (order.id === entity.id) {
      //       entity = order;
      //     }
      //     return entity;
      //   });
      // } else {
      //   state.fulfillmentEntities = state.fulfillmentEntities.filter((entity) => entity.id !== order.id);
      // }
    },
    saveOrderTrackingDetails: (state, action) => {
      state.message.error = null;
      state.actionsLoading = false;
      const { status } = action.payload;
      state.message.success = status;
    },
    // deleteOrder
    orderDeleted: (state, action) => {
      state.message.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter((el) => el.id !== action.payload.id);
    },
    // deleteOrders
    ordersDeleted: (state, action) => {
      state.message.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter((el) => !action.payload.ids.includes(el.id));
    },
    // ordersUpdateState
    ordersStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.message.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },

    // createOrder
    addOrder: (state, action) => {
      const { entity } = action.payload;
      state.entities.push(entity);
    },

    saleOrdersFetched: (state, action) => {
      const { totalCount, entities, totalByStatus } = action.payload;
      state.message.error = null;
      state.actionsLoading = false;
      state.entities = entities;
      state.totalCount = totalCount;
      state.listLoading = false;
      state.totalByStatus = totalByStatus || state.totalByStatus;
    },
    saleFulfillmentsFetched: (state, action) => {
      const { totalCount, entities, totalByStatus } = action.payload;
      state.message.error = null;
      state.actionsLoading = false;
      state.fulfillmentEntities = entities;
      state.fulfillmentTotalCount = totalCount;
      state.listLoading = false;
      state.totalByStatus = totalByStatus;
    },

    // getOrders
    findOrderByNo: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.message.error = null;
      state.orderEntities = entities;
    },

    resetFilterSearches: (state, action) => {
      state.orderEntities = null;
      state.orderListCustomerSearchResult = null;
    },

    // delete Order
    deleteOrder: (state, action) => {
      state.actionsLoading = false;
      state.message.error = null;
      const { id, message } = action.payload;
      state.entities = state.entities.filter((order) => order.id !== Number(id));
      state.message.success = message;
    },

    // findCustomers
    customersSearched: (state, action) => {
      const { entities, view } = action.payload;
      state.listLoading = false;
      state.message.error = null;
      if (view == "cart") {
        state.cartSearchResult = entities;
      } else if (view == "stepper") {
        state.stepperSearchResult = entities;
      }
    },
    validateShippingDetail: (state, action) => {
      const { message, shippingDetail } = action.payload;
      state.actionsLoading = false;
      state.message.error = null;
      state.isShippingValid = true;
      state.customer.customer_shipping_details = shippingDetail;
      state.message.success = message;
    },

    //find customer by name
    findCustomerByName: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.message.error = null;
      state.orderListCustomerSearchResult = entities;
    },

    //startActionLoading
    startActionLoading: (state, action) => {
      state.actionsLoading = action.payload.isLoading;
    },

    cardVerificationFinish: (state) => {
      state.card = {
        requiresAction: false,
        paymentIntentClientSecret: "",
      };
    },
    removeUnmountDate: (state) => {
      state.copyOrderEntity = null;
      state.park = false;
    },
    exceptionHandlerCleaner: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.modalActionsLoading = false;
    },
    setStatusBack: (state, action) => {
      // const { orderId, status } = action.payload;
      // state.fulfillmentEntities = state.fulfillmentEntities.map((entity) => {
      //   if (entity.id === orderId) {
      //     entity.status = status;
      //   }
      //   return entity;
      // });
      // state.message.success = "Status Changed Successfully";
    },
  },
});
export const {getInitialState} = ordersSlice;
